module.exports = __webpack_public_path__ + "static/media/test-pen.7b418cd7.jpg";